<template>
  <div class="popup z-index-10-fg version-updates">
    <!--New Updates Go Here-->
    <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />

    <div class="scrollable">
      <h2>Version Updates</h2>

      <div>
        <div class="version-title">Version 4.1 - 9/25/25</div>
        <ul>
          <li>First version of Pegg Enterprises CMS.</li>
          <li>Removed salespeople requirement on new contacts.</li>
          <li>Added query string key to all requests to the backend server.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 4.0.4 - 9/12/25</div>
        <ul>
          <li>Fixed MFA reset option to user settings.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 4.0.3 - 8/29/25</div>
        <ul>
          <li>Fixed delay alert bug.</li>
          <li>Other small bugs fixed.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 4.0.2 - 8/25/25</div>
        <ul>
          <li>Fixed error that prevented users from adding a new contact from a lead.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 4.0.1 - 8/25/25</div>
        <ul>
          <li>Fixed small design bugs.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 4.0 - 7/24/25</div>
        <ul>
          <li>CMS version 4.0 is now fully migrated to the cloud.</li>
          <li>New user login experience complete with password reset and MFA.</li>
          <li>New user management system and more granular user permissions.</li>
          <li>Updated user profile page to include password reset and MFA.</li>
          <li>Switched from 'Display Name' to First and Last names on profiles.</li>
          <li>Integrated sales impact report directly into CMS instead of an external standalone site.</li>
          <li>Optimized the loading of leads on the backend which improves performance more than 300x.</li>
          <li>Optimized the report creation on the backend which improves performance of the report 200x.</li>
          <li>Fixed bug where non admin users were unable to add a customer due to missing required fields.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 3.0.2 - 7/23/25</div>
        <ul>
          <li>Fixed bug where website links were not opening correctly.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 3.0.1 - 7/22/25</div>
        <ul>
          <li>Fixed bug where email checkboxes were not being cleared when switching tabs.</li>
          <li>Fixed bug where files were not opening correctly on the Leads and Contacts pages.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 3.0 - 7/18/25</div>
        <ul>
          <li>Release of version 3.0 of the software.</li>
          <li>Completely redesigned the Companies and Individuals pages, merging them into a new unified "Contacts" page.</li>
          <li>Added a new "Leads" tab to the Contacts page.</li>
          <li>Updated backend database and server architecture to support new features and enhance performance.</li>
          <li>Integrated file management directly into the Contacts page.</li>
          <li>Added new "Architect/Engineer Details" options to the Contacts page.</li>
          <li>Introduced a "Primary Contact" option for the Contacts page, currently available only for the Architects and Engineers categories.</li>
          <li>Fixed a bug where files attached to interactions were not appearing on the Leads page.</li>
          <li>Added a new "Company Report" page, allowing users to generate company lists based on filter criteria.</li>
          <li>Fixed issues with filters on the Customer Report.</li>
          <li>Removed v1.0 videos from the Help menu.</li>
          <li>Removed payments.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.14.1 - 6/30/25</div>
        <ul>
          <li>Fixed several bugs.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.14 - 6/28/25</div>
        <ul>
          <li>Added new "dead" score option for leads. Dead leads by default will not show on the leads page but can be viewed by adjusting the filters.</li>
          <li>Added new action for leads to "Mark as Dead" which will change the score to dead and create a "Marked as Dead" interaction.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.13.2 - 6/20/25</div>
        <ul>
          <li>Added new automation for 'paver quiz' leads from WI website.</li>
          <li>Fixed bug with new lead salesperson assignment.</li>
          <li>Fixed bug with lead files and history not updating when a lead was updated.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.13.1 - 5/23/25</div>
        <ul>
          <li>Fixed bug with assigning salesperson to a lead.</li>
          <li>Added new 'Clear All Reminders' option to the reminders menu.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.13 - 5/21/25</div>
        <ul>
          <li>Added new salesperson suggestion feature that recommends salespeople based on lead location.</li>
          <li>Added visual indicator for suggested salesperson in the assign salesperson dropdown.</li>
          <li>Fixed bug where email body was not being encoded correctly when sending contractor list emails.</li>
          <li>Fixed bug where contact could be assigned to lead before salesperson was assigned.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.12 - 5/17/25</div>
        <ul>
          <li>Added new actions menu to leads which includes new actions to send touchpoint emails to lead contacts.</li>
          <li>Added ability to sort by score on leads page which is the default sort.</li>
          <li>Added 'New' status to leads that have no interactions and have been created in the last 3 days.</li>
          <li>Fixed bug where creating or linking a contact to a lead was not working.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.11 - 5/15/25</div>
        <ul>
          <li>Added 'Score' to leads. This helps salespeople prioritize leads by assigning a hot, warm, or cold score to each lead.</li>
          <li>Can now set the score to change automatically when an interaction is added. This setting can be found in the administration 'Options' page under 'Interaction Types'.</li>
          <li>Optimized lead loading to improve performance.</li>
          <li>Added 'Warranty Claim' source option to leads.</li>
          <li>Fix minor design bugs and corrected backend server error handling.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.10.2 - 4/30/25</div>
        <ul>
          <li>Fixed layout issue with Website quote details on the lead page.</li>
          <li>Fixed server side bugs.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.10.1 - 4/26/25</div>
        <ul>
          <li>Added date range filter to customer report diary notes.</li>
          <li>Improved sort functionality on customer report.</li>
          <li>Added margin to printouts.</li>
          <li>Fixed bug where customer report was not always loading.</li>
          <li>Added scroll bar to long tables on several pages.</li>
          <li>Added ability to type letters to jump to specific place in multi-select dropdowns.</li>
          <li>Server side bug fixes and improvements.</li>
          <li>Other minor design improvements and bug fixes.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.10 - 4/24/25</div>
        <ul>
          <li>Entirely new customer report with new layout and design.</li>
          <li>Updated server-side database backend for improved performance and scalability.</li>
          <li>Other internal improvements and bug fixes.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.9.1 - 4/21/25</div>
        <ul>
          <li>Fixed bug on CMS authentication.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.9 - 4/18/25</div>
        <ul>
          <li>Added AI duplicate finder and merge tool.</li>
          <li>Fixed bug where certified contractor was not saving on new company.</li>
          <li>Fixed bug where deleted linked contacts and companies were still showing on the company page.</li>
          <li>Fixed bug where leads were loading large amounts inefficiently on startup.</li>
          <li>Fixed bug where new lead contactsearch was too tall for the popup.</li>
          <li>Fixed bug where reminders were not deleting when the lead it was attached to was deleted.</li>
          <li>Fixed bug where reminder was not being created when a lead was assigned to a salesperson on v1.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.8.1 - 3/28/25</div>
        <ul>
          <li>Fixed bug where quote details and quote summary were not being displayed on the lead page when arriving after CMS was opened.</li>
          <li>Fixed bug where gap in divider was not being displayed correctly on the lead page.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.8 - 3/27/25</div>
        <ul>
          <li>Overhauled the way quote requests are displayed on the lead page.</li>
          <li>Migrated to new Linux based backend server for better performance and long term stability.</li>
          <li>When creating and linking a new contact to a lead the first name and last name will now be capitalized.</li>
          <li>Other internal improvements and bug fixes.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.7.5 - 3/13/25</div>
        <ul>
          <li>Added link to new Sales Impact Report.</li>
          <li>Fixed a bug where the delay alert was not being set correctly.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.7.4 - 3/8/25</div>
        <ul>
          <li>Made source column wider.</li>
          <li>Fixed bug where system allowed invalid invoice numbers and amounts to be saved.</li>
          <li>Fixed minor bug with last activity alert.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.7.3 - 3/7/25</div>
        <ul>
          <li>Added sort on diary notes in reports.</li>
          <li>Fixed small glitch with extra comma on contact link page.</li>
          <li>Fixed a bug where the date to filter was not filtering correctly.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.7.2 - 2/18/25</div>
        <ul>
          <li>Added birthday to individuals and automatically notify assigned salespeople when it is their birthday.</li>
          <li>Fixed a bug where reminders were not closing when navigating to a contact.</li>
          <li>Fixed a bug where reminders were not loading on individual contact pages.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.7.1 - 2/5/25</div>
        <ul>
          <li>Fixed a bug where leads briefly appeared after changing a filter.</li>
          <li>Fixed an issue where reminders didn't update on pages other than the leads page.</li>
          <li>Resolved a bug that caused reports to show a security error instead of opening contacts and companies.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.7 - 2/4/25</div>
        <ul>
          <li>Added mailto links to email addresses on lead records.</li>
          <li>Quote amounts are now displayed on the leads page.</li>
          <li>Prevented confirmed orders from being completed without an assigned contact.</li>
          <li>Enhanced lead tracking by capturing more detailed channels and sources for auto-generated leads from the WI website.</li>
          <li>Automatically generates a reminder when a lead is assigned to a salesperson. Also introduced a popup for viewing individual leads outside the lead list.</li>
          <li>Implemented a delay alert for leads, postponing the red "last activity" alert until a specified date.</li>
          <li>Added a location-based filter to the leads page.</li>
          <li>Clicking a company or contact in reports now opens it in a new window.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.6.1 - 1/18/25</div>
        <ul>
          <li>Fixed bug with planning guide sync.</li>
          <li>Added address link to lead page.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.6 - 1/17/25</div>
        <ul>
          <li>Added 'Planning Guide' lead source and made system sync submissions of the planning guide forms on the WI website with CMS leads.</li>
          <li>Updated text on view interaction button so less confusing.</li>
          <li>Allowed specific user to edit Certified Contractors per Landon Pegg.</li>
          <li>Fixed bug where reminders alert noise would play even when there were no new reminders.</li>
          <li>Changed assign salesperson to add reminders instead of emails.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.5 - 12/26/24</div>
        <ul>
          <li>
            Files attached to an interaction will now be tied directly to the interaction instead of the lead. If more than one file is attached to an interaction it will now allow anyone to open the interaction and see
            the interactions details and files in a read only mode or editable mode if they are the author or an admin.
          </li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.4.2 - 11/19/24</div>
        <ul>
          <li>Fixed bug with salespeople assignment admin page.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.4.1 - 11/12/24</div>
        <ul>
          <li>Changed last activity alert to only show on uncompleted leads and only show in number of days.</li>
          <li>Added contact titles to admin options.</li>
          <li>Added delivery filter to leads page.</li>
          <li>Fixed bug where selected lead would not clear on other computers when a lead was deleted.</li>
          <li>Fixed several bugs with salespeople assignment admin page.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.4 - 10/17/24</div>
        <ul>
          <li>
            Built connection between CMS and the WI website so requests from the contact form will be automatically added as new leads. The new leads will not be assigned to a salesperson and all leads admins will be
            able to see them.
          </li>
          <li>Created live sync system on back end to keep leads up to date for all users.</li>
          <li>Delivery information can now be edited when completing a lead.</li>
          <li>Fixed minor bugs.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.3 - 10/12/24</div>
        <ul>
          <li>Added popup on contacts select menu to show info about a contact.</li>
          <li>Fixed issue with dates and interactions.</li>
          <li>Added delivery date, gate code, and delivery notes to leads. Can be added when creating a new lead or editing an existing lead as well as when adding a sent quote interaction.</li>
          <li>Renamed 'Sales Manager' permission to 'Leads Admin'.</li>
          <li>Fixed issue with sorting by last activity.</li>
          <li>Fixed minor graphical bugs.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.2.4 - 10/9/24</div>
        <ul>
          <li>Fixed graphical bugs on leads page.</li>
          <li>Fixed issue with salesperson filter showing incorrect salesperson.</li>
          <li>Can now close leads when clicking on grayed out area.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.2.3 - 10/3/24</div>
        <ul>
          <li>Restricted max width of leads page to solve squishing design issue of arrows.</li>
          <li>Can click 'enter' button when renaming a file to save new name.</li>
          <li>Fixed issue with changing display name and salespeople not showing on reports.</li>
          <li>Fixed bug showing 'created by' name twice on diary notes.</li>
          <li>Added new 'website' source option to leads.</li>
          <li>Now plays audio when a new reminder is due.</li>
          <li>Fixed error when saving or creating payments.</li>
          <li>Fixed other minor bugs.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.2.2 - 9/30/24</div>
        <ul>
          <li>Fixed bug with reports module not running reports.</li>
          <li>Reports were not printing. Fixed issue.</li>
          <li>Fixed design glitch on leads page.</li>
          <li>Changed last activity alert to only show on uncompleted leads.</li>
          <li>Fixed otherg minor bugs.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.2.1 - 9/28/24</div>
        <ul>
          <li>Fixed bug blocking the ability to save emails directly from drag and drop.</li>
          <li>Fixed bug that caused files with special characters to not open correctly.</li>
          <li>Added rename and delete functionality for files.</li>
          <li>Fixed an issue where dragging and dropping files more then one time would overwrite the previously dropped files. Now a user can drag and drop as many as they want.</li>
          <li>Changed how system handles files uploaded with the same name. It now adds a (1) to the end of a file name if a user attempts to saved a file with the same name.</li>
          <li>Updated file icons on lead page.</li>
          <li>Fixed minor design glitches.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.2 - 9/27/24</div>
        <ul>
          <li>Added Google Maps API to all address fields for address autocomplete.</li>
          <li>
            Files can now be attached to leads in several ways: through the "Add Interactions" or "Completion" pop-ups, directly on the lead itself, or initially when adding a new lead. You can easily add files by
            dragging and dropping them, or by clicking the "Attachments" button.
          </li>
          <li>Lead search will search by job name.</li>
          <li>Alert when lead has last activity of 7 days or more.</li>
          <li>Minor styling updates and bug fixes.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.1 - 9/21/24</div>
        <ul>
          <li>Copy icon on find-a-contractor that copies the contractor information to the clipboard for easy pasting into an email.</li>
          <li>Searching leads will now automatically search all leads including completed and assigned to other salespeople.</li>
          <li>Added invoice number and amount columns to leads page.</li>
          <li>Amount shows on lead creation as well as in the lead request details and in the edit request details popup.</li>
          <li>Added job name, bw quote, amount, and site address as fields to enter when creating a 'sent quote' interaction.</li>
          <li>Monor bug fixes</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 2.0 - 9/19/24</div>
        <ul>
          <li>Introducing CMS Version 2 built from the ground up with a new underlying architecture to improve performance. The Companies, Individuals, and Reports pages are still running a sandboxed version 1.</li>
          <li>All new Leads module to track customer inquires and request for quotes.</li>
          <li>New profile page so a user can manage their own profile.</li>
          <li>Updated design for the Admin module and find-a-contractor.</li>
          <li>More features coming in the near future!</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.21 - 5/9/24</div>
        <ul>
          <li>Made primary contact bold and on top of list of company contacts.</li>
          <li>Added city column to report.</li>
          <li>Created contractor lookup page.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.20.1 - 2/28/24</div>
        <ul>
          <li>Added ability for admins to assign a reminder to another person.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.20 - 2/17/24</div>
        <ul>
          <li>Added reminder functionality. Users can add reminders for themselves for a contact or company and it will alert once the day has passed.</li>
          <li>Added new dropdown on admin page for 'Reminder Types'.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.19 - 1/1/24</div>
        <ul>
          <li>Updated report functionality to show companies that have no contacts.</li>
          <li>Updated reports to fix design issue where main report panel would move below side panel.</li>
          <li>When checking 'All' under outside salesperson in a report it now selects unassigned.</li>
          <li>Fixed share functionality when company had an amperstand sybmol in name.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.18 - 9/26/23</div>
        <ul>
          <li>
            Payments are here! You can save payment methods under the <i>Payments</i> tab on a company record. It takes a special key to decrypt and view or edit a payment method. A company can have one, and only one,
            primary method. Only admins can remove payment methods.
          </li>
          <li>Pasting a website into the website field on a company record will auto remove the https so the launch shortcut will load the website correctly.</li>
          <li>Improvments with the activity log. It will now log payment activity and diary not activity on cmsmobile.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.17 - 3/24/23</div>
        <ul>
          <li>Can now select a contact when creating a diary note in a company.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.16 - 11/23/22</div>
        <ul>
          <li>Share button added to the Company and Individual pages that starts a new email with the contacts information in the body.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.15 - 4/30/22</div>
        <ul>
          <li>Certified Contractor field is now visible in reports.</li>
          <li>Companies linked to companies are now bi-directional.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.14 - 4/21/22</div>
        <ul>
          <li>Added CCB/LCB Number field for companies.</li>
          <li>Added Certified Contractor checkbox. Only visible for admins.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.13 - 2/9/22</div>
        <ul>
          <li>Ext phone now hides when windows is small.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.12 - 1/26/22</div>
        <ul>
          <li>Companies can now be linked to other companies.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.11 - 1/14/21</div>
        <ul>
          <li>A company or contact will no longer go into save mode when copying text from a field.</li>
          <li>Added checkboxes next to linked contacts emails. These are used to mass copy email addresses or send emails to multiple addresses automatically.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.10 - 12/7/20</div>
        <ul>
          <li>Added abbility to add line breaks to diary notes.</li>
          <li>Added button to email diary notes.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.9 - 11/7/20</div>
        <ul>
          <li>When creating a new linked contact it autofills the company phone numbers.</li>
          <li>Location data shows on the new records without salespeople admin page.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.8 - 5/30/20</div>
        <ul>
          <li>Made zip codes autopopulate after city and state are entered.</li>
          <li>Also made city and state autopopulate when zip code is entered.</li>
          <li>Added keyboard shortcut to copy full name from contacts. To use simply select the first or last name and press ctrl+c on your keyboard.</li>
          <li>Added same keyboard shortcut functionality to the address.</li>
          <li>Added shortcut button in the admin center under "Dropdown Selections" to immediently scroll to specific categories.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.7 - 5/6/20</div>
        <ul>
          <li>Added column and filtering capabilities for Customer Detail in Reports.</li>
          <li>Made last name required.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.6 - 5/1/20</div>
        <ul>
          <li>Added ability to filter by username in the activty log.</li>
          <li>Added diary notes in activity log.</li>
          <li>Fixed bugs when working with Department Contacts.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">
          Version 1.5 - 4/24/20
          <img
            src="..\assets\btn_video.gif"
            @click="
              $emit('showVideo', { file: 'version1.5', title: 'Version 1.5' });
              $emit('closePopup');
            " />
        </div>

        <ul>
          <li>Made addresses autofill with company info when creating a new linked contact.</li>
          <li>Added unsaved changes alert when navigating to a company's linked contact or a contact's linked company.</li>
          <li>Created new version updates help menu and deleted old one in admin.</li>
          <li>Minor bug fixes.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">
          Version 1.4 - 4/2/20
          <img
            src="..\assets\btn_video.gif"
            @click="
              $emit('showVideo', { file: 'version1.4', title: 'Version 1.4' });
              $emit('closePopup');
            " />
        </div>
        <ul>
          <li>Created new reports page.</li>
          <li>Gives the ability to create filtered reports, sort and manipulate those reports, and print or export the data.</li>
          <li>Created new checkmark for individual contacts called "Sales Contact". This checkmark indicates that it is the contact used by the salespeople.</li>
          <li>Made an override option for linked contacts so admins can set the salespeople to something other than what it's linked company is set at.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">
          Version 1.3 - 3/28/20
          <img
            src="..\assets\btn_video.gif"
            @click="
              $emit('showVideo', { file: 'version1.3', title: 'Version 1.3' });
              $emit('closePopup');
            " />
        </div>
        <ul>
          <li>Added filtering capabilities for date and action to the activity page.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">
          Version 1.2 - 3/27/20
          <img
            src="..\assets\btn_video.gif"
            @click="
              $emit('showVideo', { file: 'version1.2', title: 'Version 1.2' });
              $emit('closePopup');
            " />
        </div>
        <ul>
          <li>Blocked the ability to set or change salespeople for non admin users. This only applies to records with the category of either "Customer" or "Customer and Vendor"</li>
          <li>
            Added new admin page called "new customer w/o sales people". Used to see new customer records that need sales people assigned. Only records that have the category of "Customer" or "Customer & vendor" will
            show.
          </li>
          <li>Added city, state, and zip code to advanced search for both contacts and companies</li>
          <li>Created version history page.</li>
          <li>Fixed minor bugs.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">
          Version 1.1 - 3/6/20
          <img
            src="..\assets\btn_video.gif"
            @click="
              $emit('showVideo', { file: 'version1.1', title: 'Version 1.1' });
              $emit('closePopup');
            " />
        </div>
        <ul>
          <li>Added sort functionality to diary notes.</li>
          <li>Made status settings of contacts linked to the company they are connected to.</li>
          <li>Fixed various other bugs.</li>
        </ul>
      </div>

      <div>
        <div class="version-title">Version 1.0 - 3/3/20</div>
        <ul>
          <li>Initial Release</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
export default {
  name: 'VersionUpdates',
  emits: ['closePopup', 'showVideo'],
};
</script>

<style lang="scss" scoped>
.version-updates {
  overflow: hidden;
  .scrollable {
    overflow-y: auto;
    height: 50vh;
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }

  .version-title {
    color: #254b75;
    margin: 0;
    margin-top: 2rem;
    font-weight: 500;
    font-size: $fontSize16;

    img {
      height: 1rem;
      cursor: pointer;
      margin-left: 0.5rem;
    }
  }

  ul {
    margin: 0;
    margin-top: 0.5rem;

    li {
      margin-bottom: 0.5rem;
      font-size: $fontSize13;
    }
  }
}
</style>
